import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { clearPlansFromStore, getPlans, getPlansBySectionId, clearSectionPlansFromStore, getBookmarkedPlans } from "actions/plans";
import { getSectionByGraphId } from "actions/sections";
import { searchPlans } from "actions/search";
import LoadingCards from "components/Cards/LoadingCard";
import SectionTitle from "components/Presentation/SectionTitle";
import { PRESCHOOL } from "constants/schoolTypes";
import MultiplePlanForm from "containers/Forms/PlanningForm/MultiplePlanForm";
import MultiplePreschoolPlanForm from "containers/Forms/PlanningForm/MultiplePreschoolPlanForm";
import SinglePlanForm from "containers/Forms/PlanningForm/SinglePlanForm";
import SectionForm from "containers/Forms/SectionForm";
import ReactGantt from "containers/Gantt/ReactGantt";
import Modal from "containers/Modals/Modal";
import { getRootUrl } from "helpers/url";
import { isUserTeacher } from "helpers/user";
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import moment from "moment";
import DateTime from '_class/DateTime';
import PropTypes from "prop-types";
import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { Search as SearchInput } from 'UI/Inputs';
import { DataList, Spinner, ColorLabel, ColorLabelContainer } from 'UI';
import { connect } from "react-redux";
import { withRouter, Link } from 'react-router-dom';
import { Icon, Button, getActiveLanguage, Tabs, Tab } from "@haldor/ui";
import { setPageTitle, setPageActions } from "actions/header";
import User from "_class/User";
import { isIframe } from 'helpers/teams';
import { saveWithExpiration, getWithExpiration } from 'helpers/localstorage';
import * as microsoftTeams from "@microsoft/teams-js";

var MyPlans = /*#__PURE__*/function (_Component) {
  _inherits(MyPlans, _Component);

  var _super = _createSuper(MyPlans);

  function MyPlans(props) {
    var _this;

    _classCallCheck(this, MyPlans);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      if (_this.props.overview) {
        return true;
      }

      _this.props.clearSectionPlansFromStore();

      _this.props.setPageTitle(_this.props.translate("planning-header-overview"));
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.initComponent();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "initComponent", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var actions, user;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              actions = [];
              user = new User(_this.props.currentUser);
              microsoftTeams.app.getContext().then(function (context) {
                var section = _this.props.sections.find(function (section) {
                  return section.graphId == context.team.groupId;
                });

                if (section != null) {
                  _this.setState({
                    sectionId: section.id,
                    noSectionFound: false,
                    loading: false
                  });

                  if (_this.props.sectionPlans != null && _this.props.sectionPlans.length > 0) {
                    _this.parseRows();

                    _this.props.getPlansBySectionId(section.id).then(function () {
                      _this.parseRows();
                    });
                  } else {
                    _this.props.getPlansBySectionId(section.id).then(function () {
                      _this.parseRows();
                    });
                  }
                } else {
                  _this.setState({
                    noSectionFound: true,
                    teamsContext: context,
                    loading: false
                  });
                }
              });

              if (!_this.props.disableCreate && !user.isStudent()) {
                actions.push({
                  type: "button",
                  value: _this.props.translate("Create"),
                  onClick: _this.toggleCreatePlansForm,
                  disabled: _this.props.archived || _this.props.locked,
                  buttonType: "primary",
                  icon: "plus"
                });
              }

              if (!_this.props.overview) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return", true);

            case 6:
              _this.props.setPageActions(actions);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "loadPlansOnTenant", function () {
      _this.setState({
        loading: true
      });

      _this.props.getPlans().then(function () {
        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "parseRows", function () {
      var _this$state = _this.state,
          groups = _this$state.groups,
          rows = _this$state.rows;
      var groupId = _this.props.groupid;
      var plans = [];

      if (_this.state.sectionId != null || groupId != null) {
        plans = _this.props.sectionPlans;
      } else {
        plans = _this.props.planning;
      }

      if (plans != null) {
        rows = [];
        plans.map(function (planning) {
          // One planning object
          var isInGroups = groups.find(function (g_o) {
            return g_o.id == planning.sectionId;
          }); // Filter by groupid

          if (groupId && planning.sectionId != parseInt(groupId)) {
            return false;
          }

          var open = false;
          var showGroupTitle = true;

          if (window.location.pathname == "/planning-tab") {
            open = true;
            showGroupTitle = false;
          }

          if (!isInGroups) {
            var newGroup = {
              id: planning.sectionId,
              title: planning.section.title,
              open: open,
              showGroupTitle: showGroupTitle
            };
            groups.push(newGroup);
          }

          var url = "".concat(getRootUrl(), "plan/").concat(planning.id);
          var newRow = {
            title: planning.title,
            id: planning.id,
            borderLeft: "3px solid #997AE8",
            startDate: moment.utc(planning.timeStart).toDate(),
            climaxDate: moment(planning.timeStart).add("6", "hours").toDate(),
            planning: planning,
            groupColor: "grey",
            endDate: moment.utc(planning.timeEnd).toDate(),
            group: planning.sectionId,
            action: function action() {
              _this.props.history.push(url);
            }
          };

          if (_this.props.dateRestriction && planning.status != "PLANNING_CLOSED") {
            rows.push(newRow);
          } else if (_this.props.dateRestriction == false) {
            rows.push(newRow);
          }
        });

        _this.setState({
          groups: groups,
          rows: rows,
          loading: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleIcon", function (flip) {
      return /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        className: flip ? "i-90" : "a-90",
        style: {
          height: "7px",
          width: "15px"
        }
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "toggleCreatePlansForm", function (skipModal) {
      if (_this.state.multiplePlanFormModal) {
        if (skipModal) {
          _this.setState({
            multiplePlanFormModal: false,
            rows: null
          }, function () {
            _this.props.clearPlansFromStore();

            _this.initComponent();
          });
        } else {
          _this.setState({
            multiplePlanFormModal: false
          });
        }
      } else {
        _this.setState({
          multiplePlanFormModal: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleIcon", function (flip) {
      return /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        className: flip ? 'i-90' : 'a-90',
        style: {
          height: '12px',
          width: '15px',
          margin: 0
        }
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "goToday", function (event) {
      event.preventDefault();
      var options = _this.state.options;
      var momentDate = moment();
      options.leftBound = momentDate.startOf('week').toDate();
      options.rightBound = momentDate.endOf('week').add(3, 'weeks').toDate();
      localStorage.removeItem('gantt-leftbound');
      localStorage.removeItem('gantt-rightbound');

      _this.setState({
        options: options
      });
    });

    _defineProperty(_assertThisInitialized(_this), "goBackwards", function (event) {
      event.preventDefault();
      var options = _this.state.options;
      var leftBound = moment(options.leftBound).subtract("1", "weeks").toDate();
      var maxLeftBound = moment().startOf("week").subtract("20", "weeks").toDate();

      if (leftBound > maxLeftBound || _this.props.dateRestriction == false) {
        options.leftBound = leftBound;
        options.rightBound = moment(options.rightBound).subtract("1", "weeks").toDate();
        saveWithExpiration('gantt-leftbound', options.leftBound);
        saveWithExpiration('gantt-rightbound', options.rightBound);

        _this.setState({
          options: options
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "goForwards", function (event) {
      event.preventDefault();
      var options = _this.state.options;
      var rightBound = moment(options.rightBound).add("1", "weeks").toDate();
      var maxRightBound = moment().endOf("week").add("4", "weeks").add("20", "weeks").toDate();

      if (rightBound < maxRightBound || _this.props.dateRestriction == false) {
        options.leftBound = moment(options.leftBound).add("1", "weeks").toDate();
        options.rightBound = rightBound;
        saveWithExpiration('gantt-leftbound', options.leftBound);
        saveWithExpiration('gantt-rightbound', options.rightBound);

        _this.setState({
          options: options
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "outputForms", function () {
      var sectionId = _this.state.sectionId;

      var schoolType = _this.props.currentUser.schools.getActiveSchool(_this.props.currentUser.userId).type;

      if (sectionId != null && schoolType != PRESCHOOL) {
        return /*#__PURE__*/React.createElement(SinglePlanForm, {
          onAbort: _this.toggleCreatePlansForm,
          sectionId: sectionId,
          cloneView: false,
          editView: false
        });
      }

      if (schoolType == PRESCHOOL) {
        return /*#__PURE__*/React.createElement(MultiplePreschoolPlanForm, {
          onAbort: _this.toggleCreatePlansForm
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "teamsTabCloseForm", function () {
      _this.setState({
        noSectionFound: false
      }, function () {
        window.location = window.location.href;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderListViewRow", function (plan) {
      console.log("plan", plan);

      var planStatus = _this.props.translate('Open');

      if (plan.status == 'PLANNING_CLOSED') {
        planStatus = _this.props.translate('Closed');
      }

      if (plan.status == 'PLANNING_DRAFT') {
        planStatus = _this.props.translate('Draft');
      }

      var addedColorDots = [];

      var planSection = _this.props.sections.find(function (section) {
        return section.id == plan.section.id;
      });

      return /*#__PURE__*/React.createElement(RowItem, {
        key: plan.id,
        target: "".concat(getRootUrl(), "plan/").concat(plan.id)
      }, _this.state.me.isTeacher() ? /*#__PURE__*/React.createElement(RowCell, {
        title: ''
      }, /*#__PURE__*/React.createElement("div", {
        className: "bookmarks bookmark--toggle"
      }, plan.bookmarked ? /*#__PURE__*/React.createElement(Icon, {
        name: "Star_Fill"
      }) : /*#__PURE__*/React.createElement(Icon, {
        name: "Star",
        bw: true
      }))) : null, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('Title')
      }, plan.title), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('Status')
      }, planSection ? planStatus : _this.props.translate('No ownership')), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('Curriculums')
      }, plan.courses != null && plan.courses.length > 0 ? /*#__PURE__*/React.createElement(ColorLabelContainer, null, plan.courses.map(function (course) {
        if (addedColorDots.find(function (t) {
          return t == course.id;
        }) == null) {
          var text = course.title;
          text = course.year != null ? text + ' ' + course.year : text;
          addedColorDots.push(course.id);
          return /*#__PURE__*/React.createElement(ColorLabel, {
            key: course.id,
            tooltip: text,
            color: course.colorCode
          });
        }
      })) : null), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('Date')
      }, new DateTime(plan.timeStart ? plan.timeStart : null).getLongDate()), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('Creator')
      }, plan._Creator.firstName ? plan._Creator.firstName + ' ' : '', "  ", plan._Creator.lastName ? plan._Creator.lastName : ''));
    });

    _defineProperty(_assertThisInitialized(_this), "searchPlans", function (values) {
      _this.setState({
        loading: true
      });

      _this.props.searchPlans(values.query).then(function () {
        _this.setState({
          loading: false
        });
      });
    });

    moment.locale(getActiveLanguage());

    var _momentDate = moment();

    var _leftBound = _momentDate.startOf('week').toDate();

    var _rightBound = _momentDate.endOf('week').add(3, 'weeks').toDate();

    if (getWithExpiration('gantt-leftbound') != null) {
      _leftBound = moment(getWithExpiration('gantt-leftbound')).toDate();
    }

    if (getWithExpiration('gantt-rightbound') != null) {
      _rightBound = moment(getWithExpiration('gantt-rightbound')).toDate();
    }

    _this.state = {
      me: new User(_this.props.currentUser),
      rows: null,
      groups: [],
      sectionId: null,
      noSectionFound: false,
      loading: true,
      teamsContext: null,
      multiplePlanFormModal: false,
      options: {
        labelWidth: "20%",
        labelBorderColor: "#E4E4EB",
        labelAppendBeforeFormat: _this.props.translate("week"),
        intervalFormat: "W",
        showBorders: false,
        responsive: true,
        bootstrapped: true,
        leftBound: _leftBound,
        rightBound: _rightBound,
        placeholder: "",
        beforeClimaxColor: "white",
        afterClimaxColor: "white",
        hideFirstColumn: true,
        barStyle: {
          height: "105px",
          border: "1px solid #E4E4EB",
          showTitle: true,
          shadow: false,
          borderRadius: "4px",
          hoverPopup: false,
          showGroupTitle: true
        }
      }
    };
    return _this;
  }

  _createClass(MyPlans, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props$bookmarke;

      var _this$state2 = this.state,
          rows = _this$state2.rows,
          groups = _this$state2.groups,
          options = _this$state2.options;
      var sortedPlannings = this.props.sectionPlans;

      if (sortedPlannings != null) {
        sortedPlannings.sort(function (a, b) {
          // Sort by bookmarked first
          if (a.bookmarked && !b.bookmarked) return -1; // a comes first

          if (!a.bookmarked && b.bookmarked) return 1; // b comes first
          // If bookmarked status is the same, sort by date

          var dateA = new Date(a.timeStart);
          var dateB = new Date(b.timeStart); // Furthest in the future should be last in the list

          return dateA - dateB;
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "my_planning planning"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.multiplePlanFormModal,
        onClose: function onClose() {
          _this2.toggleCreatePlansForm(false);
        },
        title: this.props.translate("plan-create-button")
      }, this.outputForms()), /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(SectionTitle, null, this.props.overview ? /*#__PURE__*/React.createElement(Icon, {
        name: "Plans"
      }) : null, this.props.overview ? /*#__PURE__*/React.createElement("span", null, this.props.translate("planning-header-overview")) : null, this.props.overview && this.state.me.isTeacher() ? /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.toggleCreatePlansForm
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", this.props.translate("Create")) : null, this.props.dateRestriction && !this.state.loading ? /*#__PURE__*/React.createElement(Link, {
        to: "plans",
        className: "see-more"
      }, this.props.translate("show-all")) : null, !this.state.loading && !this.state.noSectionFound ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0,
          marginRight: '0.5em'
        },
        onClick: this.goBackwards
      }, this.toggleIcon(false), "\xA0"), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0,
          marginRight: '0.5em'
        },
        onClick: this.goToday
      }, this.props.translate('today')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0
        },
        onClick: this.goForwards
      }, this.toggleIcon(true), "\xA0")) : null)), /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('Show timeline'),
        route: "timeline"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }), !this.state.noSectionFound && !this.state.loading && rows != null && rows.length == 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%",
          textAlign: "center"
        }
      }, this.props.planning != null ? this.props.planning.length > 0 ? /*#__PURE__*/React.createElement("h3", null, this.props.translate("no-plans-created"), /*#__PURE__*/React.createElement("br", null)) : null : null) : null, rows != null && !this.state.noSectionFound && !this.state.loading ? /*#__PURE__*/React.createElement("div", {
        className: "gantt-container"
      }, /*#__PURE__*/React.createElement(ReactGantt, {
        options: options,
        groups: groups,
        sections: this.props.sections,
        rows: rows,
        weekTranslation: this.props.translate("week-short")
      })) : this.state.noSectionFound == false ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 1
      }) : null, this.state.noSectionFound && !this.state.loading && this.state.me.isTeacher() ? /*#__PURE__*/React.createElement(SectionForm, {
        editView: false,
        teamsContext: this.state.teamsContext,
        teamsTabCloseForm: this.teamsTabCloseForm,
        tab: "planning",
        onboarding: true
      }) : null)), /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('Show list'),
        route: "listView"
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(DataList, {
        data: sortedPlannings,
        renderRow: this.renderListViewRow,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
            style: {
              textAlign: 'center'
            }
          }, _this2.props.translate('no-results')));
        }
      })), this.state.me.isTeacher() ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('Search plan'),
        route: "search"
      }, /*#__PURE__*/React.createElement(SearchInput, {
        placeholder: this.props.translate('Search plan'),
        onSubmit: this.searchPlans,
        allowEmpty: true
      }), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(DataList, {
        data: this.props.planningSearch,
        renderRow: this.renderListViewRow,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
            style: {
              textAlign: 'center'
            }
          }, _this2.props.translate('no-results')));
        }
      })) : null, this.state.me.isTeacher() ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('Bookmarks'),
        route: "bookmarks"
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(DataList, {
        data: (_this$props$bookmarke = this.props.bookmarkedPlans) === null || _this$props$bookmarke === void 0 ? void 0 : _this$props$bookmarke.data,
        renderRow: this.renderListViewRow,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
            style: {
              textAlign: 'center'
            }
          }, _this2.props.translate('no-results')));
        }
      })) : null));
    }
  }]);

  return MyPlans;
}(Component);

function mapStateToProps(state) {
  return {
    planning: state.planning.plans,
    planningSearch: state.planning.search_results,
    sectionPlans: state.planning.sectionPlans,
    bookmarkedPlans: state.planning.bookmarkedPlans,
    sections: state.sections.educationGroups,
    translate: translate(state.Languages.translations),
    languages: state.Languages.languages,
    currentUser: state.user.currentUser,
    group: state.sections.graphSection
  };
}

export default withRouter(connect(mapStateToProps, {
  getPlans: getPlans,
  clearPlansFromStore: clearPlansFromStore,
  setPageTitle: setPageTitle,
  getPlansBySectionId: getPlansBySectionId,
  clearSectionPlansFromStore: clearSectionPlansFromStore,
  setPageActions: setPageActions,
  getSectionByGraphId: getSectionByGraphId,
  searchPlans: searchPlans,
  getBookmarkedPlans: getBookmarkedPlans
})(MyPlans));